import { Maybe } from '@csp/csp-common-model';
import { BioSampleProcessedValueType, BioSampleTypeText, BioSampleValueType } from '@csp/csp-common-hbs-model';
import { isDefined } from '@csp/csp-common-util';
import { BookedPatientVisit } from '../../patient-visits/model/BookedPatientVisit';
import { BioSampleSelectPropsMapper } from './BioSampleSelectPropsMapper';

const COMMON_SAMPLE_TYPES = [BioSampleValueType.OTHER];
const COMMON_PROCESSED_SAMPLE_TYPES = [BioSampleProcessedValueType.OTHER];

const mapToSampleTypeTexts = (bookedVisit: Maybe<BookedPatientVisit>): BioSampleTypeText[] => {
  if (bookedVisit?.hbsSampleTypes.length) {
    return bookedVisit.hbsSampleTypes;

    // TODO CMS based sample types was introduced in R14 - enum mapped content should be removed in future release
  } else if (bookedVisit?.visitRequest.hbs.sampleTypes.length) {
    // The common sample types will be added later in call stack
    const sampleTypesExceptCommon = bookedVisit.visitRequest.hbs.sampleTypes.filter(
      sampleType => !COMMON_SAMPLE_TYPES.includes(sampleType),
    );
    return BioSampleSelectPropsMapper.mapSampleEnumToText(sampleTypesExceptCommon);
  } else {
    return [];
  }
};

const mapToProcessedSampleTypeTexts = (bookedVisit: Maybe<BookedPatientVisit>): BioSampleTypeText[] => {
  if (bookedVisit?.hbsProcessedSampleTypes.length) {
    return bookedVisit.hbsProcessedSampleTypes;

    // TODO CMS based sample types was introduced in R14 - enum mapped content should be removed in future release
  } else if (bookedVisit?.visitRequest.hbs.processedSampleTypes.length) {
    // The common sample types will be added later in call stack
    const sampleTypesExceptCommon = bookedVisit.visitRequest.hbs.processedSampleTypes.filter(
      sampleType => !COMMON_PROCESSED_SAMPLE_TYPES.includes(sampleType),
    );
    return BioSampleSelectPropsMapper.mapProcessedSampleEnumToText(sampleTypesExceptCommon);
  } else {
    return [];
  }
};

const mapSampleTypeValueToText = (value: Maybe<string>): Maybe<string> => {
  if (value && value !== BioSampleValueType.UNKNOWN) {
    const sampleText = BioSampleSelectPropsMapper.mapSampleEnumToText([value as BioSampleValueType], undefined).filter(
      isDefined,
    )[0];
    if (sampleText) {
      return sampleText;
    } else {
      return value;
    }
  } else {
    return undefined;
  }
};

const mapProcessedSampleTypeValueToText = (value: Maybe<string>): Maybe<string> => {
  if (value && value !== BioSampleProcessedValueType.UNKNOWN) {
    const sampleText = BioSampleSelectPropsMapper.mapProcessedSampleEnumToText(
      [value as BioSampleProcessedValueType],
      undefined,
    ).filter(isDefined)[0];
    if (sampleText) {
      return sampleText;
    } else {
      return value;
    }
  } else {
    return undefined;
  }
};

// TODO CMS based sample types was introduced in R14 - enum mapped content should be removed in future release
export const BioSampleSampleTypeMapper = {
  mapToSampleTypeTexts,
  mapProcessedSampleTypeValueToText,
  mapSampleTypeValueToText,
  mapToProcessedSampleTypeTexts,
};
